export { PhilosophyPage as default } from '@/components/pages/Company/Philosophy'
